import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "variant", "size", "thickness"];
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
var rotate = /*#__PURE__*/keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var Wrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "Spinner__Wrapper",
  componentId: "sc-1vzu4va-0"
})(["", " ", " border-bottom-color:transparent;border-radius:50%;display:inline-block;box-sizing:border-box;animation:", " 0.7s linear infinite;"], function (_ref) {
  var $size = _ref.$size;
  return css(["height:", "px;width:", "px;"], $size, $size);
}, function (_ref2) {
  var $size = _ref2.$size,
    theme = _ref2.theme,
    $variant = _ref2.$variant,
    $thickness = _ref2.$thickness;
  return css(["border:", "px solid ", ";"], $thickness !== null && $thickness !== void 0 ? $thickness : $size / 10, $variant === 'accent' ? theme.kallisto.color.border.interactive.borderPrimaryDefault : 'white');
}, rotate);
export var Spinner = function Spinner(_ref3) {
  var _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'accent' : _ref3$variant,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 28 : _ref3$size,
    thickness = _ref3.thickness,
    otherProps = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    "data-testid": "spinner",
    role: "status"
  }, otherProps, {
    className: className,
    $variant: variant,
    $size: size,
    $thickness: thickness
  }));
};